<template>
  <router-view />
</template>

<script>
export default {
  name: "app-country"
};
</script>

<style lang="scss" scoped></style>
